///
/// Copyright (c) 2017-present, Siklu Ltd.
/// All rights reserved.
///

export const ACTIONS_TOOLBAR_CONSTANTS = {
    DEFAULT_ZOOM_LEVEL: 17,
    DEBOUNCE_TIMEOUT: 750
} as const;
